<script setup lang="ts">
import TrainersTable from "../components/trainers/TrainersTable.vue";
</script>

<template>
    <TrainersTable />
</template>
